<template>
  <li class="vr-location-card">
    <div>
      <div class="vr-location-card__title--container">
        <p class="vr-location-card__title">{{ content.title }}</p>
      </div>
      <div>
        <Image :source="content.image" class="vr-location-card__image" />
      </div>
    </div>
  </li>
</template>

<script>
import Image from '@/components/global/Image.vue'

export default {
  name: 'VRLocationCard',
  components: { Image },
  props: {
    border: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
